import { handleActions } from 'redux-actions';
import * as ActionCreators from '../actionCreators/credentials';

const defaultState = {
  credentialList: {
    credentials: [],
    pagination: {
      page: 1,
      currentPage: 1,
      perPage: 25,
    }
  },
  bulkAddCredentials: {
    total: 0,
    requestId: '',
    processed: 0,
    render: 0,
    failed: 0,
    success: 0,
    type: 0,// 0=INPROGRESS, 1=SUCCESS, 2=FAILED
    show: false,
    orgId: 0,
  },
};

const credentialsReducer = handleActions(
  {
    [ActionCreators.getCredentialList]: (state, { payload }) => {
      return {
        ...state,
        credentialList: {
          credentials: payload?.appendData ? [...(state?.credentialList?.credentials || []), ...(payload?.data?.credentials || [])] : payload?.data?.credentials || [],
          pagination: payload?.data?.pagination || {
            page: 1,
            currentPage: 1,
            perPage: 25,
          }
        }
      };
    },
    [ActionCreators.setBulkAddDetails]: (state, { payload }) => {
      return {
        ...state,
        bulkAddCredentials: {
          ...state.bulkAddCredentials,
          ...payload
        }
      };
    },
    [ActionCreators.clearCredentialList]: (state) => {
      return {
        ...state,
        credentialList: {
          credentials: [],
          pagination: {
            page: 1,
            currentPage: 1,
            perPage: 25,
          }
        }
      };
    },
  },
  defaultState,
);

export default credentialsReducer;
